<template>
  <section class="manufacturers">
    <div class="container">
      <div :class="['manufacturers__wrapper', { 'manufacturers__wrapper--cards': cards }]">
        <div class="manufacturers__info">
          <div class="manufacturers__info-block">
            <div class="manufacturers__info-top">
              <block-line></block-line>
              <h2>{{ textOr(content?.brandsTitle, 'Manufacturers') }}</h2>
            </div>
              <h3>{{ textOr(content?.brandsSubtitle, 'We stock thousands of automation and control components from leading OEM') }}</h3>
            <p>{{ textOr(content?.brandsText, defaultBrandsText) }}</p>
          </div>
        </div>
        <div :class="['manufacturers__block', { 'manufacturers__block--text brand-names--home': asText, 'manufacturers__block--cards': cards }]">
          <!-- Бренды: админка → Каталог → Бренды → «Показывать на главной».
               Текстом или логотипами — админка → Сайт → Главная страница → Бренды. -->
          <div v-for="item in visibleBrands" :key="item.id" class="manufacturers__block-card">
            <router-link :to="{ name: 'manufacturer', params: { manufacturer: item.slug} }" class="block-overlay"></router-link>
            <div v-if="asText" class="manufacturers__block-name">
              <span :class="['brand-name', 'brand-name--' + textStyle]" v-html="brandName(item.name)"></span>
            </div>
            <span v-if="cards" class="manufacturers__card-go" aria-hidden="true">
              <svg width="16" height="16" viewBox="0 0 20 20" fill="none"><path d="M3.5 10h12.5M11 5l5 5-5 5" stroke="#6083c0" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </span>
          </div>
          <div class="manufacturers__block-card" :style="allCardStyle">
            <router-link to="/manufacturers" class="block-overlay"></router-link>
            <div class="manufacturers__block-all">
              <div class="manufacturers__block-arrow">
                <picture>
                  <img :src="siteImg('manufacturers-arrow.svg')" alt="manufacturers-arrow" />
                </picture>
              </div>
              <span>View all</span>
              <i v-if="cards" class="manufacturers__all-line"></i>
            </div>
          </div>
        </div>
        <p v-if="asText && note" class="manufacturers__note">{{ note }}</p>
      </div>
    </div>
  </section>
  <modal-form v-if="isVisibleModalForm" @toggle-modal="toggleModalForm"></modal-form>
</template>

<script>
import {useSiteImg} from "@/functions/siteImages";
import ModalForm from "@/components/pages/productPage/ModalForm.vue";
import BlockLine from "@/components/ui/BlockLine.vue";

import {textOr, useHomeBrands} from "@/functions/siteSettings";

export default {
  components: { BlockLine, ModalForm },
  props: {
    content: { type: Object, default: null },
  },
  setup() {
    return {
      siteImg: useSiteImg(), brands: useHomeBrands() };
  },
  computed: {
    asText() {
      return true; // только названия, логотипы брендов не используются
    },
    textStyle() {
      const s = this.content?.brandsTextStyle;
      return ["light", "bold", "spaced", "large", "accent", "manrope"].includes(s) ? s : "light";
    },
    /** Стиль «Manrope»: отдельные карточки в ряд на всю ширину, текст слева (по макету владельца). */
    cards() {
      return this.asText && this.textStyle === "manrope";
    },
    /** «View all» занимает пустое место в последнем ряду (сетка 3 колонки на компьютере). */
    allCardStyle() {
      if (!this.cards) return {};
      const rest = 3 - ((this.visibleBrands.length + 1) % 3 || 3);
      return rest > 0 ? { "--all-span": String(rest + 1) } : {};
    },
    note() {
      return (this.content?.brandsNote ?? "").trim();
    },
    visibleBrands() {
      const list = this.brands ?? [];
      return list;
    },
  },
  data() {
    return {
      isVisibleModalForm: false,
      defaultBrandsText: "We stock thousands of automation and control components from leading OEMs, all accessible to you from a single place. If it’s not in stock, our multilingual team will scour the globe to find you the part you need for the best price.",
    };
  },
  methods: {
    toggleModalForm() {
      this.isVisibleModalForm = !this.isVisibleModalForm;
      this.isVisibleModalForm
        ? document.body.classList.add("body-overlay")
        : document.body.classList.remove("body-overlay");
    },
    textOr,
    /** Название бренда заглавными; после «+» разрешаем перенос строки. */
    brandName(name) {
      const esc = String(name ?? "").toUpperCase()
          .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      return esc.replace(/\+/g, "+<wbr>");
    },
  },
};
</script>

<style scoped>
.manufacturers {
  overflow: hidden;
}
.manufacturers__block-all {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.manufacturers__block-all span {
  font-family: "Circe-Bold";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
}
.manufacturers__block-arrow {
  width: 19px;
  height: 19px;
  margin-bottom: 10px;
}
.manufacturers__block-arrow img {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
}
.manufacturers__wrapper {
  position: relative;
  z-index: 2;
  padding-top: 103px;
  padding-bottom: 77px;
  display: grid;
  grid-template-columns: minmax(0, max-content) 1fr;
  column-gap: 102px;
}
.manufacturers__info {
  max-width: 451px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.manufacturers__info-top {
  display: flex;
  align-items: center;
  margin-bottom: 26px;
}
.manufacturers__info-top h2 {
  font-family: "Circe-Bold";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 100%;
  color: #272930;
}
.manufacturers__info h3 {
  font-size: 36px;
  line-height: 100%;
  margin-bottom: 26px;
}
.manufacturers__info p {
  font-size: 18px;
  line-height: 140%;
  opacity: 0.5;
}

.manufacturers__block {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.manufacturers__block--text {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.manufacturers__block-name {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  text-align: center;
}
.manufacturers__note {
  grid-column: 2;
  margin-top: 14px;
  font-size: 13px;
  line-height: 1.4;
  color: rgba(39, 41, 48, 0.45);
}
@media (max-width: 1199px) {
  .manufacturers__note {
    grid-column: auto;
  }
}
@media (max-width: 767px) {
  .manufacturers__block--text {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .manufacturers__note {
    font-size: 11px;
  }
}
.manufacturers__block-card {
  position: relative;
  background-color: transparent;
  transition: background-color 0.25s ease;
  border: 2px solid #f4f4f5;
  border-right: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 260px;
}

.manufacturers__block-card::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 0;
  height: 6px;
  background-color: #6083c0;
  transition: 0.5s ease;
}
.manufacturers__block-card:hover {
  background-color: #f1fafc;
}
.manufacturers__block-card:nth-child(4) {
  border-right: 2px solid #f4f4f5;
}
.manufacturers__block-card:last-child {
  border-right: none;
  border-bottom: none;
}
.manufacturers__block-card:nth-last-child(-n + 4) {
  border-top: none;
}
.manufacturers__block-image {
  width: 100%;
  height: 100%;
}
.manufacturers__block-image img {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
}
@media (min-width: 990px) {
  .manufacturers__block-card:hover::after {
    width: 100%;
    transition: 0.5s ease;
  }
}
@media (max-width: 1600px) {
  .manufacturers__wrapper {
    column-gap: 30px;
  }
  .manufacturers__info {
    max-width: 400px;
  }
}
@media (max-width: 1400px) {
  .manufacturers__info {
    max-width: 312px;
  }
}

@media (max-width: 1199px) {
  .manufacturers__info {
    max-width: 100%;
  }
  .manufacturers__wrapper {
    grid-template-columns: 1fr;
    column-gap: 0;
    row-gap: 29px;
  }
}
@media (max-width: 767px) {
  .manufacturers__block-all span {
    font-size: 12px;
  }
  .manufacturers__wrapper {
    padding-top: 62px;
    padding-bottom: 36px;
  }
  .manufacturers__info-top {
    margin-bottom: 20px;
  }

  .manufacturers__info-top h2 {
    font-size: 14px;
    line-height: 100%;
  }
  .manufacturers__info h3 {
    font-size: 22px;
    margin-bottom: 16px;
  }
  .manufacturers__info p {
    font-size: 14px;
  }
  .manufacturers__block-image {
    padding: 10px;
  }
  .manufacturers__block {
    grid-template-columns: repeat(3, 1fr);
  }
  .manufacturers__block-card {
    min-height: unset;
    height: 110px;
  }
  .manufacturers__block-card:nth-child(4) {
    display: none;
  }
  .manufacturers__block-card:nth-last-child(-n + 2),
  .manufacturers__block-card:nth-child(3) {
    border-right: 2px solid #f4f4f5;
  }
  .manufacturers__block-card:last-child {
    grid-column: 1 / 4;
    min-height: unset;
    height: 43px;
    border-right: 2px solid #f4f4f5;
    border-bottom: 2px solid #f4f4f5;
  }
  .manufacturers__block-all {
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding-left: 21px;
    padding-right: 29px;
  }
  .manufacturers__block-arrow {
    order: 1;
    width: 12px;
    height: 12px;
    margin-bottom: 0;
  }
}
/* ===== Карточки брендов в стиле «Manrope» (макет владельца 12.10.2026) ===== */
.manufacturers__wrapper--cards {
  /* слева текст, справа сетка; сетка по высоте подстраивается под текст */
  grid-template-columns: minmax(0, 5fr) minmax(0, 9fr);
  column-gap: clamp(32px, 3vw, 56px);
  align-items: stretch;
}
.manufacturers__wrapper--cards .manufacturers__info {
  max-width: none;
  justify-content: flex-start;
}
/* заголовок — как главный заголовок страницы («Wide selection of ...») */
.manufacturers__wrapper--cards .manufacturers__info h3 {
  font-size: 46px;
  line-height: 100%;
  margin-bottom: 26px;
}
@media (min-width: 768px) and (max-height: 1000px) {
  .manufacturers__wrapper--cards .manufacturers__info h3 {
    font-size: 38px;
  }
}
.manufacturers__block--cards {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-auto-rows: minmax(140px, 1fr);
  gap: 12px;
  align-self: stretch;
}
.manufacturers__block--cards .manufacturers__block-card,
.manufacturers__block--cards .manufacturers__block-card:nth-child(4),
.manufacturers__block--cards .manufacturers__block-card:last-child,
.manufacturers__block--cards .manufacturers__block-card:nth-last-child(-n + 4) {
  display: flex;
  min-height: 140px;
  height: auto;
  grid-column: auto;
  align-items: flex-start;
  justify-content: center;
  padding: 0 28px;
  border: 1px solid #e3e7ee;
  border-radius: 6px;
  background-color: #fff;
  transition: background-color 0.25s ease, box-shadow 0.25s ease;
}
.manufacturers__block--cards .manufacturers__block-card::after {
  display: none;
}
.manufacturers__block--cards .manufacturers__block-card:hover {
  background-color: #f1fafc;
  box-shadow: 0 8px 22px rgba(11, 36, 84, 0.06);
}
.manufacturers__block--cards .manufacturers__block-name {
  justify-content: flex-start;
  padding: 0;
  text-align: left;
}
.manufacturers__block--cards .brand-name {
  text-align: left;
}
.manufacturers__block--cards .brand-name--manrope::after {
  margin: 14px 0 0;
  width: 44px;
  height: 3px;
  border-radius: 2px;
}
.manufacturers__card-go {
  position: absolute;
  right: 12px;
  top: 12px;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 4px 14px rgba(11, 36, 84, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.25s ease;
  pointer-events: none;
}
.manufacturers__block-card:hover .manufacturers__card-go {
  opacity: 1;
}
.manufacturers__block--cards .manufacturers__block-all,
.manufacturers__block--cards .manufacturers__block-card:last-child .manufacturers__block-all {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0;
  width: auto;
}
.manufacturers__block--cards .manufacturers__block-arrow {
  order: 0;
  width: 19px;
  height: 19px;
  margin-bottom: 12px;
}
.manufacturers__block--cards .manufacturers__block-all span {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: #0b2454;
}
@media (min-width: 768px) {
  .manufacturers__block--cards .manufacturers__block-card:last-child {
    grid-column: span var(--all-span, 1);
  }
}
.manufacturers__all-line {
  display: block;
  width: 44px;
  height: 3px;
  border-radius: 2px;
  margin-top: 14px;
  background: #7bcfb7;
}
@media (max-width: 1199px) {
  .manufacturers__wrapper--cards {
    grid-template-columns: 1fr;
    row-gap: 32px;
  }
  .manufacturers__block--cards {
    grid-auto-rows: minmax(120px, auto);
  }
  .manufacturers__block--cards .manufacturers__block-card,
  .manufacturers__block--cards .manufacturers__block-card:nth-child(4),
  .manufacturers__block--cards .manufacturers__block-card:last-child,
  .manufacturers__block--cards .manufacturers__block-card:nth-last-child(-n + 4) {
    padding: 0 22px;
    min-height: 120px;
  }
}
@media (max-width: 767px) {
  .manufacturers__wrapper--cards .manufacturers__info h3 {
    font-size: 26px;
    margin-bottom: 16px;
  }
  .manufacturers__block--cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: minmax(92px, auto);
    gap: 10px;
  }
  .manufacturers__block--cards .manufacturers__block-card,
  .manufacturers__block--cards .manufacturers__block-card:nth-child(4),
  .manufacturers__block--cards .manufacturers__block-card:last-child,
  .manufacturers__block--cards .manufacturers__block-card:nth-last-child(-n + 4) {
    padding: 0 16px;
    min-height: 92px;
  }
  .manufacturers__block--cards .manufacturers__block-name {
    padding-right: 0;
  }
  .manufacturers__card-go {
    display: none;
  }
  .manufacturers__block--cards .manufacturers__block-all span {
    font-size: 15px;
  }
  /* «View all» на телефоне — во всю ширину, невысокой полосой */
  .manufacturers__block--cards .manufacturers__block-card:last-child {
    grid-column: 1 / -1;
    min-height: 60px;
  }
  .manufacturers__block--cards .manufacturers__block-card:last-child .manufacturers__block-all {
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }
  .manufacturers__block--cards .manufacturers__block-card:last-child .manufacturers__block-arrow {
    order: 1;
    width: 14px;
    height: 14px;
    margin: 0;
  }
  .manufacturers__block--cards .manufacturers__all-line {
    display: none;
  }
}
</style>
